module.exports = __webpack_public_path__ + "static/media/fedex.32df3ec6.png";